/// <reference path="Utilities/_reference.ts" />

module YVR.Welcome {
	// Utilities
	import date = YVR.Utilities.Dates;
	import logger = YVR.Utilities.Logger;
	import i18n = YVR.Utilities.I18n;


	// Default options
	const options = {
		serviceUrl: `/${i18n.getCurrentLanguage()}/_api/Weather`
	};


	// CSS classes
	const classes = {
		container: 'yvr-welcome__container'
	};


	// Elements
	const elements = {
		container: $(`.${classes.container}`)
	};


	/**
	 * Initialise the module.
	 */
	function main() {
	}


	/**
	 * Get the current weather data from our weather service.
	 * @returns {obj} A jQuery promise object.
	 */
	function getWeatherData() {
		return $.get({
			url: options.serviceUrl,
			success(data) {
				logger.log('[welcome][getWeatherData] Successfully retrieved weather data.');
			}
		});
	}


	/**
	 * Transforms the weather data for the template.
	 * @param {obj} data The data from the weather service.
	 * @returns {obj} A jQuery promise object.
	 */
	function transformWeatherData(data) {
		data.time = date.getCurrentTime();

		return data;
	}


	/**
	 * Renders the time and weather template.
	 * @param {obj} data The data from the weather service.
	 */
	function renderWeatherData(data) {
		const source = $('#yvr-welcome-template').html();
		const template = Handlebars.compile(source);

		const html = template(data);

		$(`.${classes.container}`).html(html);
	}

	main();
}
